import React, { useState, useEffect, Fragment } from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'

import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import Input from '@material-ui/core/Input'
import MenuItem from '@material-ui/core/MenuItem'
import SubmitButton from '../../../../../Components/Form/SubmitButton'
import { styles } from './styles'

const AssignSpyToolbar = ({
  numSelected,
  classes,
  spies,
  onConfirm,
  title,
}) => {
  const [disabledButton, setDisabledButton] = useState(false)
  const [selectedSpy, setSelectedSpy] = useState(null)
  useEffect(() => {
    if (numSelected > 0 && selectedSpy) {
      setDisabledButton(false)
    } else {
      setDisabledButton(true)
    }
  }, [selectedSpy, numSelected])

  return (
    <div
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>{title}</div>
      {numSelected > 0 ? (
        <Fragment>
          <div className={classes.inputWrapper}>
            <form>
              <FormControl className={classes.formControl}>
                <InputLabel
                  shrink
                  id="select-spy-simple"
                  htmlFor="select-spy-simple"
                >
                  Spy
                </InputLabel>
                <Select
                  labelId="select-spy-simple"
                  value={selectedSpy}
                  onChange={event => {
                    setSelectedSpy(event.target.value)
                  }}
                  input={
                    <Input name="select-spy-simple" id="select-spy-simple" />
                  }
                  displayEmpty
                >
                  <MenuItem value={null}>
                    <em>None</em>
                  </MenuItem>
                  {spies
                    .sort((a, b) =>
                      (a.firstName + ' ' + a.lastName).localeCompare(
                        b.firstName + ' ' + b.lastName,
                      ),
                    )
                    .map(option => (
                      <MenuItem value={option.id} key={option.id}>
                        {option.firstName} {option.lastName}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </form>
          </div>
          <div>
            <SubmitButton
              disabled={disabledButton}
              value="Confirm"
              onClick={() => {
                onConfirm(selectedSpy)
                setDisabledButton(true)
              }}
            />
          </div>
        </Fragment>
      ) : null}
    </div>
  )
}

export default injectStyles(styles)(AssignSpyToolbar)
